<template>
    <page-loading v-if="loading"></page-loading>
    <vx-page-layout v-else :layout="props.messageStandardId ? 'sidebar' : 'create'">
        <template v-slot:title>
            <span v-if="!props.messageStandardId" class="inline-flex items-center gap-3">
                <font-awesome-icon widthAuto :icon="faListUl" class="text-base"></font-awesome-icon>
                <span>New Standards</span>
            </span>
            <span v-else data-test="message-standard-header">{{ messageStandard?.name }}</span>
        </template>

        <template v-if="!props.messageStandardId" v-slot:description>
            Messaging standard to control the quality of your team's campaign messages.
        </template>

        <template v-if="props.messageStandardId" v-slot:subtitle>
            <a
                :href="`/settings/teams/${teamId}#/message-standards`"
                class="no-underline! text-sky-600! text-base font-normal"
            >
                <font-awesome-icon widthAuto class="mr-1" :icon="faArrowLeft"></font-awesome-icon>
                All Brand Standards
            </a>
        </template>

        <template v-if="props.messageStandardId" v-slot:sidebar>
            <page-sidebar appearance="nested" :links="sidebarLinks" data-test="message-standard-sidebar"></page-sidebar>
        </template>

        <slot></slot>
    </vx-page-layout>
</template>
<script setup>
import { VxPageLayout } from '@voxie/frontend-components';
import PageLoading from '~/components/general/PageLoading.vue';
import PageSidebar from '~/components/general/PageSidebar.vue';
import { computed, onMounted, provide } from 'vue';
import { PAGE_HEADING_LEVEL } from '~/provides/pageHeadingLevel';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faArrowLeft, faListUl } from '@fortawesome/pro-solid-svg-icons';
import { useMessageStandardDetails } from './useMessageStandardDetails';

const props = defineProps({
    messageStandardId: {
        type: [String, Number],
        required: false,
    },
});

const teamId = Spark.state.currentTeam.id;

provide(PAGE_HEADING_LEVEL, 'h2');

const { mount, messageStandard, loading } = useMessageStandardDetails();

const sidebarLinks = computed(() => [
    { href: `/settings/teams/${teamId}/message-standards/${props.messageStandardId}`, label: 'Details' },
    {
        href: `/settings/teams/${teamId}/message-standards/${props.messageStandardId}/targets`,
        label: 'Targets',
    },
]);

onMounted(() => {
    mount(props.messageStandardId);
});
</script>
